// ===== custom.js 共通ユーティリティ（全ブロックから参照） =====
function cieloDebounce(fn, wait) {
  var t;
  return function () {
    var ctx = this;
    var args = arguments;
    clearTimeout(t);
    t = setTimeout(function () { fn.apply(ctx, args); }, wait);
  };
}

// rAF throttle (scrollなど高頻度イベント向け)
function cieloRafThrottle(fn) {
  var ticking = false;
  var lastArgs;
  return function () {
    lastArgs = arguments;
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      fn.apply(null, lastArgs);
    });
  };
}

function cieloFindNear(el, selector) {
  if (!el || !selector || typeof selector !== 'string') return null;
  // まずは自身の配下
  var found = el.querySelector(selector);
  if (found) return found;
  // Shopify section単位で探索（複数スライダー同居時の衝突防止）
  var sectionRoot = el.closest ? el.closest('.shopify-section, [id^="shopify-section-"], section') : null;
  if (sectionRoot) {
    found = sectionRoot.querySelector(selector);
    if (found) return found;
  }
  // 近い祖先を数段探索
  var cur = el.parentElement;
  var hops = 0;
  while (cur && hops < 6) {
    found = cur.querySelector(selector);
    if (found) return found;
    cur = cur.parentElement;
    hops++;
  }
  // 最後の手段：document（従来互換）
  return document.querySelector(selector);
}

var __cieloUid = 0;
function cieloUniqueId(prefix) {
  __cieloUid += 1;
  return (prefix || 'cielo') + '-' + __cieloUid;
}

function cieloHasSlick() {
  return (window.jQuery && jQuery.fn && typeof jQuery.fn.slick === 'function');
}

function cieloInitSwiperInScope(rootEl, selector, options) {
  if (typeof Swiper === 'undefined') return;
  if (!rootEl || !rootEl.querySelectorAll) return;
  var nodes = rootEl.querySelectorAll(selector);
  if (!nodes || !nodes.length) return;
  nodes.forEach(function (el) {
    if (el && el.swiper) return;
    var opt = Object.assign({}, options || {});
    if (opt.navigation) {
      opt.navigation = Object.assign({}, opt.navigation);
      if (typeof opt.navigation.nextEl === 'string') opt.navigation.nextEl = cieloFindNear(el, opt.navigation.nextEl) || opt.navigation.nextEl;
      if (typeof opt.navigation.prevEl === 'string') opt.navigation.prevEl = cieloFindNear(el, opt.navigation.prevEl) || opt.navigation.prevEl;
    }
    if (opt.pagination) {
      opt.pagination = Object.assign({}, opt.pagination);
      if (typeof opt.pagination.el === 'string') opt.pagination.el = cieloFindNear(el, opt.pagination.el) || opt.pagination.el;
    }
    new Swiper(el, opt);
  });
}

function cieloInitSlickLightbox($scope) {
  if (!cieloHasSlick()) return;
  if (!(jQuery.fn && typeof jQuery.fn.slickLightbox === 'function')) return;
  var $root = ($scope && $scope.length) ? $scope : $(document);
  var $targets = $root.find('.lightbox').filter(function () { return !$(this).data('cielo-slicklightbox-inited'); });
  if (!$targets.length) return;
  $targets.data('cielo-slicklightbox-inited', true);
  $targets.slickLightbox({
    itemSelector: 'a.open-lightbox',
    caption: 'caption',
    prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
    navigateByKeyboard: true,
    layouts: {
      closeButton: '<button class="close"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z" fill="white"></path></svg></button>'
    }
  });
}

function cieloUnslickWithin($scope) {
  if (!cieloHasSlick()) return;
  var $root = ($scope && $scope.length) ? $scope : $(document);
  $root.find('.slick-initialized').each(function () {
    try { $(this).slick('unslick'); } catch (e) { /* noop */ }
  });
}

// Slick: 商品ギャラリー（main/thumb）を“同じラッパー内だけ”でペアリングして初期化
function cieloInitSlickProductGalleries($scope) {
  if (!cieloHasSlick()) return;
  var $root = ($scope && $scope.length) ? $scope : $(document);

  $root.find('.slider-wrapper').each(function () {
    var $wrap = $(this);
    var $main = $wrap.find('.product-main-slider').first();
    var $thumb = $wrap.find('.product-thumb-slider').first();
    if (!$main.length || !$thumb.length) return;

    var gid = $wrap.attr('data-cielo-gallery-id');
    if (!gid) {
      gid = cieloUniqueId('gallery');
      $wrap.attr('data-cielo-gallery-id', gid);
    }

    // asNavFor は selector で渡す（確実に同一ギャラリー内だけを参照）
    var mainSel = '[data-cielo-gallery-id="' + gid + '"] .product-main-slider';
    var thumbSel = '[data-cielo-gallery-id="' + gid + '"] .product-thumb-slider';

    if (!$main.hasClass('slick-initialized')) {
      $main.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        speed: 1000,
        loop: true,
        asNavFor: thumbSel,
        autoplay: false,
        responsive: [{
          breakpoint: 576,
          settings: {
            arrows: true,
            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            dots: false,
          }
        }]
      });
    }

    if (!$thumb.hasClass('slick-initialized')) {
      $thumb.slick({
        slidesToShow: 5,
        arrows: true,
        asNavFor: mainSel,
        dots: false,
        speed: 1000,
        slidesToScroll: 1,
        touchMove: true,
        focusOnSelect: true,
        loop: true,
        infinite: true,
        vertical: true,
        verticalSwiping: true,
        rtl: false,
        // inline SVGのid重複（url(#id)）を避けるため、ユニークIDにする
        prevArrow: (function () {
          var gradId = cieloUniqueId('thumbGradPrev');
          return '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="' + gradId + '" x1="6" y1="18" x2="18" y2="6" gradientUnits="userSpaceOnUse"><stop stop-color="#0098ff"/><stop offset="1" stop-color="#7c34c8"/></linearGradient></defs><polyline points="7 15 12 9 17 15" stroke="url(#' + gradId + ')"></polyline></svg></button>';
        })(),
        nextArrow: (function () {
          var gradId = cieloUniqueId('thumbGradNext');
          return '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="' + gradId + '" x1="6" y1="6" x2="18" y2="18" gradientUnits="userSpaceOnUse"><stop stop-color="#0098ff"/><stop offset="1" stop-color="#7c34c8"/></linearGradient></defs><polyline points="7 9 12 15 17 9" stroke="url(#' + gradId + ')"></polyline></svg></button>';
        })(),
        responsive: [{
          breakpoint: 576,
          settings: {
            vertical: false,
            slidesToShow: 5,
          }
        }]
      });
    }
  });
}

// Slick: ギャラリー以外のスライダー初期化（セクション再描画でも再利用）
function cieloInitSlickMiscSliders($scope) {
  if (!cieloHasSlick()) return;
  var $root = ($scope && $scope.length) ? $scope : $(document);

  var $extra = $root.find('.product-extra-slider');
  if ($extra.length) {
    $extra.not('.slick-initialized').slick({
      prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      dots: false,
      loop: true,
      infinite: true,
      speed: 600,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      ]
    });
  }

  var $related = $root.find('.related-blogs-slider');
  if ($related.length) {
    $related.not('.slick-initialized').slick({
      prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      dots: false,
      loop: true,
      infinite: true,
      speed: 600,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
      ]
    });
  }

  var $twoRow = $root.find('.blog-two-row-slider');
  if ($twoRow.length) {
    $twoRow.not('.slick-initialized').slick({
      rows: 2,
      autoplay: false,
      arrows: true,
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 4,
      slidesToScroll: 3,
      prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  var $testimonial = $root.find('.testimonial-slider');
  if ($testimonial.length) {
    $testimonial.not('.slick-initialized').slick({
      autoplay: false,
      slidesToShow: 2,
      speed: 1000,
      slidesToScroll: 1,
      prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
      dots: false,
      buttons: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
}

// Swiper 二重初期化ガード（Swiperは要素に `.swiper` を生やす）
function cieloInitSwiperAll(selector, options) {
  if (typeof Swiper === 'undefined') return;
  var nodes = document.querySelectorAll(selector);
  if (!nodes || !nodes.length) return;
  nodes.forEach(function (el) {
    if (el && el.swiper) return;
    // 要素ごとに options を複製し、navigation/pagination を近傍へスコープ
    var opt = Object.assign({}, options || {});
    if (opt.navigation) {
      opt.navigation = Object.assign({}, opt.navigation);
      if (typeof opt.navigation.nextEl === 'string') opt.navigation.nextEl = cieloFindNear(el, opt.navigation.nextEl) || opt.navigation.nextEl;
      if (typeof opt.navigation.prevEl === 'string') opt.navigation.prevEl = cieloFindNear(el, opt.navigation.prevEl) || opt.navigation.prevEl;
    }
    if (opt.pagination) {
      opt.pagination = Object.assign({}, opt.pagination);
      if (typeof opt.pagination.el === 'string') opt.pagination.el = cieloFindNear(el, opt.pagination.el) || opt.pagination.el;
    }
    // selector文字列ではなく要素で渡すと多重要素でも安全
    new Swiper(el, opt);
  });
}

$(document).ready(function () {
  var hasSwiper = (typeof Swiper !== 'undefined');
  var hasSlick = cieloHasSlick();
  var hasSlickLightbox = (hasSlick && typeof jQuery.fn.slickLightbox === 'function');

  // ===== overlay 共通クローズ（用途混在による競合を防ぐ） =====
  function closeReview() {
    if (!$('.product-review.open-model').length) return;
    $(".product-review").removeClass("open-model");
    $('body').removeClass('no-scroll open');
    $('.overlay').removeClass('active');
  }

  function closeMobileFilter() {
    var drawer = document.querySelector('menu-drawer.mobile-facets__wrapper');
    var details = drawer && (drawer.mainDetailsToggle || drawer.querySelector('details'));
    var isOpen = details && details.hasAttribute('open');
    if (!$('body').hasClass('mobile-open') && !isOpen) return;

    var summary = details && details.querySelector(':scope > summary');
    if (drawer && typeof drawer.closeMenuDrawer === 'function') {
      drawer.closeMenuDrawer(new Event('close'), summary || false);
    } else if (details) {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
    $('.overlay').removeClass('active');
    if (summary && typeof summary.focus === 'function') {
      window.setTimeout(function () {
        if (summary.isConnected) summary.focus({ preventScroll: true });
      }, 0);
    }
  }

  function closeQuickview() {
    if (!$('body').hasClass('quick-open')) return;
    $('body').removeClass('no-scroll quick-open');
    $('.overlay').removeClass('active');
    $('.quickview-popup').hide();
  }

  function closeCart() {
    if (!$('body').hasClass('cartOpen')) return;
    $('body').removeClass('no-scroll cartOpen');
  }

  // overlay は1箇所で受けて「今開いているもの」だけを閉じる
  $(document).off('click.cieloOverlay', '.overlay').on('click.cieloOverlay', '.overlay', function () {
    closeReview();
    closeMobileFilter();
    closeQuickview();
    closeCart();
  });

  /**** recent-slider *****/
  if (hasSwiper && document.querySelector(".recent-slider")) {
    cieloInitSwiperAll(".recent-slider", {
      slidesPerView: 1,
      spaceBetween: 5,
      loop: false,
      speed: 800,
      navigation: {
        nextEl: ".swiper-button-next.recent-arrow",
        prevEl: ".swiper-button-prev.recent-arrow",
      },
      breakpoints: {
        1200: {
          slidesPerView: 5,
        },
        991: {
          slidesPerView: 4,
        },
        767: {
          slidesPerView: 4,
        },
        575: {
          slidesPerView: 3,
        },
        320: {
          slidesPerView: 2,
        },
      },
    });
  }

  // ===== DOMの組み替え（存在チェック＋二重実行防止） =====
  jQuery(".product-write-review").off('click.cieloReview').on('click.cieloReview', function (e) {
    $(".product-review").toggleClass("open-model");
    $('body').addClass('no-scroll open');
    $('.overlay').addClass('active');
  });
  jQuery(".review-close-icon").off('click.cieloReviewClose').on('click.cieloReviewClose', function (e) {
    closeReview();
  });
  var $cartItems = jQuery('.cart__items-wrapper');
  var $cartFooter = jQuery('.cart__footer-wrapper');
  if ($cartItems.length && $cartFooter.length && !$cartItems.first().closest('.cart-page-section').length) {
    $cartItems.add($cartFooter).wrapAll('<section class="cart-page-section padding-bottom"><div class="container"><div class="row"></div></div></section>');
    var $title = jQuery('.cart-page-section .section-title.main');
    if ($title.length) $title.prependTo('.cart-page-section > .container');
  }

  // `layout/theme.liquid` 上は header -> main なので、不要なDOM移動は避ける
  var $header = jQuery('header').first();
  var $main = jQuery('main').first();
  if ($header.length && $main.length && $header.next()[0] !== $main[0]) {
    $main.insertAfter($header);
  }
  // countdown 機能は未使用のため削除（転送量/保守性改善）

  /***** On scroll header Sticky（passive + rAF throttle） *****/
  (function () {
    var headerEl = document.querySelector('header');
    if (!headerEl) return;
    var lastState = null;
    var onScroll = cieloRafThrottle(function () {
      var shouldStick = (window.scrollY || window.pageYOffset || 0) >= 50;
      if (shouldStick === lastState) return;
      lastState = shouldStick;
      headerEl.classList.toggle('head-sticky', shouldStick);
    });

    // テーマエディタ等で再実行されても重複しないようにする
    if (window.__cieloHeaderStickyHandler) {
      window.removeEventListener('scroll', window.__cieloHeaderStickyHandler);
    }
    window.__cieloHeaderStickyHandler = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // notify me
  $(document).off('click.cieloNotify', '.notify-btn').on('click.cieloNotify', '.notify-btn', function (e) {
    e.preventDefault();
    $('#notify-me-wrapper').show();
  });
  $(document).off('click.cieloNotify', '.notify-popup-close').on('click.cieloNotify', '.notify-popup-close', function (e) {
    e.preventDefault();
    $('#notify-me-wrapper').hide();
  });
  /***** Announcebar hide *****/
  $('#announceclose').off('click.cieloAnnounce').on('click.cieloAnnounce', function () {
    $('.announcebar').slideUp();
  });
  //  /********* Wrapper top space ********/
  //  var header_hright = $('header').outerHeight();
  //  $('header').next('.wrapper').css('margin-top', header_hright + 'px');  
  /***** Mobile Menu *****/
  $(document).off('click.cieloMobileMenu', '#menu').on('click.cieloMobileMenu', '#menu', function () {
    $(".mobile-menu-wrapper, body").toggleClass("active-menu");
  });
  $(document).off('click.cieloMobileMenu', '.menu-close-icon svg').on('click.cieloMobileMenu', '.menu-close-icon svg', function () {
    $(".mobile-menu-wrapper, body").toggleClass("active-menu");
  });
  /********* Cart Popup ********/
  $(document).off('click.cieloCart', '.main-cart').on('click.cieloCart', '.main-cart', function (e) {
    $('body').addClass('no-scroll cartOpen');
  });
  $(document).off('click.cieloCart', '.closecart').on('click.cieloCart', '.closecart', function (e) {
    closeCart();
  });
  /***** Mobile Filter Popup *****/
  // MenuDrawer owns filter open/close state for pointer and keyboard parity.
  $(document).off('click.cieloMobileFilter', '.mobile-facets__open');
  $(document).off('click.cieloMobileFilterClose', '.close-filter,.apply-btn');
  /*********  size Popup  ********/
  $(document).off('click.cieloSize', '.size-btn').on('click.cieloSize', '.size-btn', function () {
    $(".size-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(document).off('click.cieloCloseSearch', '.close-search').on('click.cieloCloseSearch', '.close-search', function () {
    $(".size-popup").removeClass("active");
    $(".search-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  $(document).off('click.cieloSize', '.close-btn').on('click.cieloSize', '.close-btn', function () {
    $(".size-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  /*****  Header Search Popup  *****/
  $(document).off('click.cieloSearch', '.search-header a').on('click.cieloSearch', '.search-header a', function () {
    $(".search-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  /***** Cookie Js *****/
  $(document).off('click.cieloCookie', '.cookie-close').on('click.cieloCookie', '.cookie-close', function () {
    $('.cookie').slideUp();
  });
  /***** Subscribe popup（重複ハンドラ統合） *****/
  $(document).off('click.cieloSubscribe', '.close-sub-btn').on('click.cieloSubscribe', '.close-sub-btn', function () {
    $('.subscribe-popup').slideUp();
    $('.subscribe-overlay').removeClass('open');
  });
  /*****  Multi-level accordion nav  *****/
  $(document).off('click.cieloAcnav', '.acnav-label').on('click.cieloAcnav', '.acnav-label', function () {
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav-list');
    if (parent.hasClass('is-open')) {
      list.slideUp('fast');
      parent.removeClass('is-open');
    } else {
      list.slideDown('fast');
      parent.addClass('is-open');
    }
  });
  /*****  TAB Js *****/
  $(document).off('click.cieloTabs', 'ul.tabs li').on('click.cieloTabs', 'ul.tabs li', function () {
    var $tab = $(this);
    var $wrapper = $tab.closest('.tabs-wrapper');
    if (!$wrapper.length) return;
    if ($tab.hasClass('active')) return;
    var tabId = $tab.attr('data-tab');
    if (!tabId) return;

    $wrapper.find('ul.tabs li').removeClass('active');
    $wrapper.find('.tabs-container .tab-content').removeClass('active');
    $tab.addClass('active');
    $wrapper.find('.tabs-container .tab-content[id="' + tabId + '"]').addClass('active');
  });

  if (hasSlick) {
    cieloInitSlickMiscSliders($(document));
  }
  /***** PRODUCT SLIDER（main/thumb の誤接続防止）*****/
  if (hasSlick) {
    cieloInitSlickProductGalleries($(document));
  }
  /***** Slick lightbox *****/
  if (hasSlickLightbox && $('.lightbox').length > 0) {
    cieloInitSlickLightbox($(document));
  }

  // currency
  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function (element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  // quickview
  if ($('.quickview-popup').length) {
    // Quickview: 連打/多重リクエスト対策
    var qvXhr = null;
    var qvLoading = false;

    $(document).off('click.cieloQuickview', '.quickview-close').on('click.cieloQuickview', '.quickview-close', function (e) {
      e.preventDefault();
      closeQuickview();
    });

    $(document).off('click.cieloQuickview', '.quickview-btn').on('click.cieloQuickview', '.quickview-btn', function (e) {
      e.preventDefault();
      $('body').addClass('no-scroll quick-open');
      $('.overlay').addClass('active');
      var handle = $(this).find('a').data('handle');
      if (!handle) return;
      var href = '/products/' + handle + '?view=qv';

      // 進行中があれば破棄して、最新だけを生かす
      if (qvXhr && qvXhr.readyState !== 4) {
        try { qvXhr.abort(); } catch (err) { /* noop */ }
      }
      if (qvLoading) {
        // abort直後の多重起動を避ける（次のtickで再入可）
        return;
      }
      qvLoading = true;
      $('body').addClass('quick-loading');

      qvXhr = $.ajax({
        url: href,
        method: 'GET',
        dataType: 'html'
      }).done(function (product) {
        var $qv = $('.quickview_popup_data');
        // 既存インスタンスを破棄してから差し替え（繰り返しopenでのリーク/不整合防止）
        cieloUnslickWithin($qv);
        $qv.html(product);

        if (hasSlick) {
          cieloInitSlickProductGalleries($qv);
          cieloInitSlickLightbox($qv);
        }
      }).fail(function (_xhr, status) {
        // abort は想定内（何もしない）
        if (status === 'abort') return;
        // 最低限のフォールバック（空のままにならないように）
        try {
          $('.quickview_popup_data').html('<div class="quickview-error" style="padding:16px;">読み込みに失敗しました。時間をおいて再度お試しください。</div>');
        } catch (err) { /* noop */ }
      }).always(function () {
        qvLoading = false;
        $('body').removeClass('quick-loading');
      });

      $('.quickview-popup').show();
    });
  }
  // end quickview

  // ===== Shopifyテーマエディタ対応（セクション再読み込み時の再初期化）=====
  if (window.Shopify && Shopify.designMode && !window.__cieloDesignModeBound) {
    window.__cieloDesignModeBound = true;

    document.addEventListener('shopify:section:load', function (evt) {
      var root = (evt && evt.target) ? evt.target : document;
      var $root = $(root);

      // Slick
      if (hasSlick) {
        cieloInitSlickMiscSliders($root);
        cieloInitSlickProductGalleries($root);
        cieloInitSlickLightbox($root);
      }

      // Swiper（セクション内だけを対象）
      if (typeof Swiper !== 'undefined') {
        cieloInitSwiperInScope(root, ".recent-slider", {
          slidesPerView: 1,
          spaceBetween: 5,
          loop: false,
          speed: 800,
          navigation: {
            nextEl: ".swiper-button-next.recent-arrow",
            prevEl: ".swiper-button-prev.recent-arrow",
          },
          breakpoints: {
            1200: { slidesPerView: 5 },
            991: { slidesPerView: 4 },
            767: { slidesPerView: 4 },
            575: { slidesPerView: 3 },
            320: { slidesPerView: 2 },
          },
        });

        cieloInitSwiperInScope(root, ".shop-protab-slider", {
          slidesPerView: 3,
          slidesPerGroup: 1,
          autoplay: false,
          speed: 600,
          loop: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".swiper-button-next.protab-arrow",
            prevEl: ".swiper-button-prev.protab-arrow",
          },
          breakpoints: {
            1201: { slidesPerView: 3, slidesPerGroup: 1 },
            576: { slidesPerView: 2.2, slidesPerGroup: 1 },
            100: { slidesPerView: 2.2, slidesPerGroup: 1 },
          },
        });

        cieloInitSwiperInScope(root, ".product-center-slider", {
          slidesPerView: 5.5,
          slidesPerGroup: 1,
          autoplay: false,
          centeredSlides: true,
          spaceBetween: 20,
          speed: 800,
          loop: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          breakpoints: {
            1601: { slidesPerView: 5.5, slidesPerGroup: 1 },
            1301: { slidesPerView: 4.5, slidesPerGroup: 1 },
            992: { slidesPerView: 3.5, slidesPerGroup: 1 },
            576: { spaceBetween: 0, slidesPerView: 2.5, slidesPerGroup: 1 },
            100: { spaceBetween: 0, slidesPerView: 1.8, slidesPerGroup: 1 },
          },
        });

        cieloInitSwiperInScope(root, ".client-logo-slider", {
          slidesPerView: 5,
          slidesPerGroup: 1,
          autoplay: false,
          speed: 100,
          loop: true,
          centeredSlides: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: ".swiper-button-next.brand-arrow",
            prevEl: ".swiper-button-prev.brand-arrow",
          },
          breakpoints: {
            1201: { slidesPerView: 5, slidesPerGroup: 1 },
            992: { slidesPerView: 4, slidesPerGroup: 1 },
            576: { slidesPerView: 3, slidesPerGroup: 1 },
            100: { slidesPerView: 2, slidesPerGroup: 1 },
          },
        });
      }
    });

    // セクション削除時：初期化済みインスタンスを明示的に破棄（メモリ/イベントの積み上がり防止）
    document.addEventListener('shopify:section:unload', function (evt) {
      var root = (evt && evt.target) ? evt.target : null;
      if (!root) return;
      var $root = $(root);

      // Slick
      try { cieloUnslickWithin($root); } catch (e) { /* noop */ }

      // slickLightbox
      if (window.jQuery && jQuery.fn && typeof jQuery.fn.slickLightbox === 'function') {
        $root.find('.lightbox').each(function () {
          try {
            // プラグイン実装差を吸収しつつ破棄を試みる
            $(this).slickLightbox('destroy');
          } catch (e) {
            // destroyが無い/失敗してもDOMが消えるので致命的ではない
          }
          try { $(this).removeData('cielo-slicklightbox-inited'); } catch (e) { /* noop */ }
        });
      }

      // Swiper
      try {
        root.querySelectorAll('.swiper, .swiper-container').forEach(function (el) {
          if (el && el.swiper && typeof el.swiper.destroy === 'function') {
            try { el.swiper.destroy(true, true); } catch (e) { /* noop */ }
          }
        });
      } catch (e) { /* noop */ }
    });
  }
});

if ($(".my-acc-column").length > 0) {
  jQuery(function ($) {
    var topMenuHeight = $("#daccount-nav").outerHeight();
    $("#account-nav").menuScroll(topMenuHeight);
    $(".account-list li:first-child").addClass("active");
  });
  // COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
  jQuery.fn.extend({
    menuScroll: function (offset) {
      var topMenu = this;
      var topOffset = offset ? offset : 0;
      var $menuItems = $(topMenu).find("a");
      var lastId;

      // Save all menu items into scrollItems array
      var $scrollItems = $($menuItems).map(function () {
        var href = $(this).attr("href");
        if (!href || href.charAt(0) !== '#') return;
        var $item = $(href);
        if ($item.length) return $item;
      });

      function getFromTop() {
        return (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0) + topOffset;
      }

      function updateActiveLink() {
        var windowSize = window.innerWidth || $(window).width();
        var fromTop = getFromTop();
        var offsetAdjust = (windowSize <= 767) ? 250 : 0;

        var current = $($scrollItems).map(function () {
          if ($(this).offset().top - offsetAdjust <= fromTop) return this;
        });
        current = current[current.length - 1];
        var id = current && current.length ? current[0].id : "";
        if (lastId === id) return;
        lastId = id;
        $($menuItems)
          .parent().removeClass("active")
          .end().filter("[href='#" + id + "']").parent().addClass("active");
      }

      function scrollToHref(href) {
        var $target = $(href);
        if (!$target.length) return;
        var offsetTop = $target.offset().top - topOffset;
        var windowSize = window.innerWidth || $(window).width();
        var adjust = (windowSize <= 767) ? 200 : 100;
        $('html, body').stop().animate({ scrollTop: offsetTop - adjust }, 300);
      }

      // 重複バインド防止（scroll/resize増殖を抑止）
      $(window).off('scroll.menuScroll resize.menuScroll orientationchange.menuScroll');

      // When the menu item is clicked, scroll to the #id element
      $(topMenu).off('click.menuScroll').on("click.menuScroll", "a", function (e) {
        var href = $(this).attr("href");
        if (!href || href.charAt(0) !== '#') return;
        e.preventDefault();
        scrollToHref(href);
      });

      var onScroll = cieloRafThrottle(updateActiveLink);
      var onResize = cieloDebounce(updateActiveLink, 120);

      // removeEventListenerできるようにグローバルに保持（増殖防止）
      if (window.__cieloMenuScrollScrollHandler) {
        window.removeEventListener('scroll', window.__cieloMenuScrollScrollHandler);
      }
      if (window.__cieloMenuScrollResizeHandler) {
        $(window).off('resize.menuScroll orientationchange.menuScroll', window.__cieloMenuScrollResizeHandler);
      }
      window.__cieloMenuScrollScrollHandler = onScroll;
      window.__cieloMenuScrollResizeHandler = onResize;

      window.addEventListener('scroll', onScroll, { passive: true });
      $(window).on('resize.menuScroll orientationchange.menuScroll', onResize);
      updateActiveLink();
    }
  });
}

// ===== resize/orientationchange の統合（debounce） =====
(function () {
  function updateWrapperTopSpace() {
    var $header = $('header').first();
    var $wrapper = $header.next('.wrapper');
    if (!$header.length || !$wrapper.length) return;
    var headerHeight = $header.outerHeight();
    $wrapper.css('margin-top', headerHeight + 'px');
  }

  function responsiveMenu() {
    var $col = $('.product-filter-column');
    if (!$col.length) return;
    var isMobile = (window.innerWidth || $(window).width()) < 768;
    if (isMobile) {
      var $target = $('.product-heading-row .container .row');
      if ($target.length && !$col.parent().is($target)) $col.prependTo($target);
    } else {
      var $targetDesktop = $('.product-list-row');
      if ($targetDesktop.length && !$col.parent().is($targetDesktop)) $col.prependTo($targetDesktop);
    }
  }

  var onResize = cieloDebounce(function () {
    updateWrapperTopSpace();
    responsiveMenu();
  }, 120);

  $(window).off('load.cieloLayout').on('load.cieloLayout', function () {
    updateWrapperTopSpace();
    responsiveMenu();
  });
  $(window).off('resize.cieloLayout orientationchange.cieloLayout').on('resize.cieloLayout orientationchange.cieloLayout', onResize);
})();
if (typeof Swiper !== 'undefined' && document.querySelector(".shop-protab-slider")) cieloInitSwiperAll(".shop-protab-slider", {
  slidesPerView: 3,
  slidesPerGroup: 1,
  autoplay: false,
  speed: 600,
  loop: true,
  // a11y: false,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".swiper-button-next.protab-arrow",
    prevEl: ".swiper-button-prev.protab-arrow",
  },
  breakpoints: {
    1201: {
      slidesPerView: 3,
      slidesPerGroup: 1
    },
    576: {
      slidesPerView: 2.2,
      slidesPerGroup: 1
    },
    100: {
      slidesPerView: 2.2,
      slidesPerGroup: 1
    }
  },
});
if (typeof Swiper !== 'undefined' && document.querySelector(".product-center-slider")) cieloInitSwiperAll(".product-center-slider", {
  slidesPerView: 5.5,
  slidesPerGroup: 1,
  autoplay: false,
  centeredSlides: true,
  spaceBetween: 20,
  speed: 800,
  loop: true,
  // a11y: false,
  observer: true,
  observeParents: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1601: {
      slidesPerView: 5.5,
      slidesPerGroup: 1
    },
    1301: {
      slidesPerView: 4.5,
      slidesPerGroup: 1
    },
    992: {
      slidesPerView: 3.5,
      slidesPerGroup: 1
    },
    576: {
      spaceBetween: 0,
      slidesPerView: 2.5,
      slidesPerGroup: 1
    },
    100: {
      spaceBetween: 0,
      slidesPerView: 1.8,
      slidesPerGroup: 1
    }
  },
});
if (typeof Swiper !== 'undefined' && document.querySelector(".client-logo-slider")) cieloInitSwiperAll(".client-logo-slider", {
  slidesPerView: 5,
  slidesPerGroup: 1,
  autoplay: false,
  speed: 100,
  loop: true,
  centeredSlides: true,
  // a11y: false,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".swiper-button-next.brand-arrow",
    prevEl: ".swiper-button-prev.brand-arrow",
  },
  breakpoints: {
    1201: {
      slidesPerView: 5,
      slidesPerGroup: 1
    },
    992: {
      slidesPerView: 4,
      slidesPerGroup: 1
    },
    576: {
      slidesPerView: 3,
      slidesPerGroup: 1
    },
    100: {
      slidesPerView: 2,
      slidesPerGroup: 1
    }
  },
});
